import { React, createContext, useEffect, useState, useContext } from "react"
const PickingContext = createContext()

export function PickingContextProvider({ children }) {
  const [modifiedProducts, setModifiedProducts] = useState([]) // Almacena los productos modificados

  const updateProduct = (sgapickingsecuen, artcodigo, newInfo, fetchedPickingSugerido) => {
    setModifiedProducts((prev) => {
      // Crear una clave para buscar el producto en fetchedPickingSugerido
      const originalProduct = fetchedPickingSugerido.find(
        (product) => product.sgapickingsecuen === sgapickingsecuen && product.artcodigo === artcodigo,
      )

      console.log(originalProduct)

      if (!originalProduct) {
        console.error("Producto original no encontrado en fetchedPickingSugerido")
        return prev // Si no se encuentra, no hacemos ningún cambio
      }

      // Verificar si el producto ya fue modificado
      const existingProductIndex = prev.findIndex(
        (product) => product.sgapickingsecuen === sgapickingsecuen && product.artcodigo === artcodigo,
      )

      if (existingProductIndex !== -1) {
        // Si el producto ya fue modificado, lo actualizamos
        const updatedProducts = [...prev]
        updatedProducts[existingProductIndex] = {
          ...originalProduct, // Mantener la estructura original del producto
          ...updatedProducts[existingProductIndex], // Mantener los cambios anteriores
          ...newInfo, // Aplicar los nuevos cambios
        }
        console.log("midificadoo")
        return updatedProducts
      } else {
        console.log("nuevo")
        return [
          ...prev,
          {
            ...originalProduct, // Mantener la estructura original del producto
            ...newInfo, // Aplicar los nuevos cambios
          },
        ]
      }
    })
  }

  return <PickingContext.Provider value={{ modifiedProducts, updateProduct }}>{children}</PickingContext.Provider>
}

export { PickingContext }
